"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var urls = {
    home: '/',
    login: '/login',
    accessKeyLogin: '/acc',
    loginParts: {
        accessCode: 'code',
        selectOrg: 'selectorg',
        forgotPassword: 'forgotPassword',
        resetPassword: 'resetPassword',
        external: 'ext',
    },
    logout: '/logout',
    preview: {
        home: '/preview', // {taskId}
        // program: '/preview/p', // {programId}/{moduleIndex?}/{taskIndex?}
        // module: '/preview/m', // {moduleId}/{taskIndex?}
        // task: '/preview/t', // {taskId}
    },
    singlepage: '/pre',
    outsideProgram: {
        home: '/prg',
        task: '/prg/t',
        program: '/prg/p',
        programSelect: '/prg/s',
    },
    public: {
        home: '/public',
        program: '/public/p',
        module: '/public/m',
        programLink: '/public/link', // page for id lookup and redirect to program or module
    },
    external: {
        home: '/ext',
        consent: '/ext/consent',
    },
    inside: {
        home: '/inside',
        profile: '/inside/profile',
        chat: '/inside/chat',
        videochat: '/inside/call',
        program: '/inside/program',
        programLink: '/inside/link',
        pages: {
            home: '/inside/p/',
            calendar: '/inside/p/calendar',
            videos: '/inside/p/videos',
            favourites: '/inside/p/favourites',
            sleepDiary: '/inside/p/sleep',
            activityDiary: '/inside/p/activity',
            prints: '/inside/p/prints',
            feedback: '/inside/p/feedback',
            elements: '/inside/p/elements',
            consent: '/inside/p/consent',
            singlepage: '/inside/p/pre',
        },
        parts: {
            resumeLatest: 'continue',
        },
    },
};
exports.default = urls;
